import Component from '../Component';
export default class DivComponent extends Component {
}
